import * as React from "react";
import { HRQuestionId } from "../../messages";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion } from "../../messages/HR";
import { Signature } from "../widgets/Signture";
import { GenericInputHeader } from "./GenericInputHeader";

interface GenericSignatureInputProps {
    hrSignatureQuestionWithStatus: HRQuestionWithStatus<HRQuestion.SignatureQuestion | HRQuestion.GeneralSignatureQuestion>;
    isHidden: boolean;
    onChange: (newVal: string | null, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

export class GenericSignatureInput extends React.Component<GenericSignatureInputProps> {
    constructor(props: GenericSignatureInputProps) {
        super(props);
    }

    handleSignatureSave = (dataUrl: string | null) => {
        this.props.onChange(dataUrl, this.props.hrSignatureQuestionWithStatus.question.id);
        this.props.onBlur(this.props.hrSignatureQuestionWithStatus.question.id);
    }

    // TODO if the signature already exsited in the server we would like show jpeg with date
    render() {
        const question = this.props.hrSignatureQuestionWithStatus.question;
        const status = this.props.hrSignatureQuestionWithStatus.status;
        let answer: string | null = null;

        if (typeof question.answer === "string") {
            answer = question.answer.toString();
        } else if (typeof question.answer === "object" && question.answer !== null) {
            if (question.answer.signature !== null) {
                answer = question.answer.signature.toString();
            }
        }
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <div
                    className={"form-group floating-label-form-group controls mb-0 pb-2 floating-label-form-group-with-value"}
                >
                    <GenericInputHeader status={status} questionText={question.questionText}/>
                    <div className="GenericSignatureInput__signatureContainer">
                        <Signature
                            initialData={answer}
                            onChange={(dataUrl) => this.handleSignatureSave(dataUrl)}
                        />
                    </div>
                </div>
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericSignatureInput.tsx